import { styled } from '~/styled'

export const DialogActionBar = styled('div', {
  base: [
    'border-t',
    'border-grey-300',
    'p-4',
    'flex',
    'gap-4',
    'shadow-[0_-6px_6px_-1px_rgba(51,51,51,0.05)]'
  ]
})
